export default function FingerprintIcon({ size = 20, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.75"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            {...props}
        >
            <path d="M6.5 6.2A8 8 0 0 1 20 12v1" />
            <path d="M4 12a8 8 0 0 1 .6-3" />
            <path d="M8 18.5c.6-1.8 1-3.8 1-6.5a3 3 0 0 1 6 0v1.5" />
            <path d="M12 12v1.5c0 2.6-.6 5-1.7 7" />
            <path d="M15 17.5c-.2 1.2-.5 2.3-.9 3.3" />
            <path d="M4.5 16c.6-1.1.9-2.4.9-4" />
            <path d="M19.6 16.5c.2-.8.3-1.6.4-2.5" />
        </svg>
    );
}
